import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=7cb2a6a6&"
import script from "./RegisterForm.vue?vue&type=script&lang=js&"
export * from "./RegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputText: require('/home/runner/work/lareverde-shop/lareverde-shop/components/inputs/InputText.vue').default,Checkbox: require('/home/runner/work/lareverde-shop/lareverde-shop/components/inputs/Checkbox.vue').default})
